module.exports = __webpack_public_path__ + "img/en.5966d066.png";